import { cn, tw } from "@utils/tailwind";

const container = tw`container-flexible grid md:grid-cols-6 md:gap-x-5 lg:grid-cols-12 2xl:gap-x-10`;
const item = tw`md:col-span-6 lg:col-span-10 xl:col-span-9 2xl:col-span-8 2xl:col-start-2`;
const itemShrinked = cn(item, "max-w-4xl");

export const gridStyles = { container, item, itemShrinked };
